import { http } from '@/repositories/http'
import store from '@/store/index'
import { HikiatekinRepository, HikiatekinRepositoryImpl } from '@/repositories/fuzoku-meisai/kaikei-kijun/hikiatekinRepository'
import {
  KoteishisanRepository,
  KoteishisanRepositoryImpl
} from '@/repositories/fuzoku-meisai/kaikei-kijun/koteishisanRepository'
import { KariirekinRepository, KariirekinRepositoryImpl } from '@/repositories/fuzoku-meisai/kaikei-kijun/kariirekinRepository'
import {
  YukashoukenRepository,
  YukashoukenRepositoryImpl
} from '@/repositories/fuzoku-meisai/kaikei-kijun/yukashoukenRepository'
import {
  MokurokuRepository,
  MokurokuRepositoryImpl
} from '@/repositories/fuzoku-meisai/kaikei-kijun/mokurokuRepository'
import {
  JigyouhiRepository,
  JigyouhiRepositoryImpl
} from '@/repositories/fuzoku-meisai/kaikei-kijun/jigyouhiRepository'

type Repositories = {
  mokuroku: MokurokuRepository
  hikiatekin: HikiatekinRepository;
  koteishisan: KoteishisanRepository;
  kariirekin: KariirekinRepository;
  yukashouken: YukashoukenRepository;
  jigyouhi: JigyouhiRepository;
}

const fuzokuKaikeiKijunUri = 'fuzoku/kaikei-kijun'

export const kaikeikijunRepositories: Repositories = {
  mokuroku: new MokurokuRepositoryImpl(http, fuzokuKaikeiKijunUri, store.state),
  hikiatekin: new HikiatekinRepositoryImpl(http, fuzokuKaikeiKijunUri, store.state),
  koteishisan: new KoteishisanRepositoryImpl(http, fuzokuKaikeiKijunUri, store.state),
  kariirekin: new KariirekinRepositoryImpl(http, fuzokuKaikeiKijunUri, store.state),
  yukashouken: new YukashoukenRepositoryImpl(http, fuzokuKaikeiKijunUri, store.state),
  jigyouhi: new JigyouhiRepositoryImpl(http, fuzokuKaikeiKijunUri, store.state)
}
